'use client';

import { useState } from 'react';
import Image from 'next/image';
import { motion, AnimatePresence } from 'motion/react';

import { IBranchBenefitPreview } from 'app/interfaces/branches';
import { defaultProcessText } from 'app/utility/textProcessing';

export default function AnswerCardMobile({
  title,
  description,
  image
}: IBranchBenefitPreview) {
  const [isOpen, setIsOpen] = useState(false);

  const onCardClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="p-5 bg-graphite-dark rounded-xl" onClick={onCardClick}>
      <h3
        className="text-h1 xl:text-p1 uppercase xl:normal-case pb-4"
        dangerouslySetInnerHTML={{
          __html: defaultProcessText(title as string)
        }}
      />
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className="text-p3 overflow-hidden"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 }
            }}
            transition={{ duration: 0.8 }}
          >
            <div
              className="pb-4"
              dangerouslySetInnerHTML={{
                __html: defaultProcessText(description as string)
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
      {!!image && (
        <Image src={image.url} alt={image.alt ?? ''} width={67} height={32} />
      )}
    </div>
  );
}
